import React, { useMemo } from 'react';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import { dataGridTextSorter } from '../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import DataGrid from '../../../../common/DataGrid/DataGrid.jsx';
import PropTypes from 'prop-types';
import { Spinner } from '../../../../common/index.jsx';
import { useTranslation } from 'react-i18next';

const UsefulLinksTable = ({ links, onDelete, onDetailClick }) => {
  const { t } = useTranslation();
  const titleTextFilterProps = useDataGridTextFilter('title');
  const titleUrlFilterProps = useDataGridTextFilter('url');

  const columns = useMemo(
    () => [
      {
        title: t('Názov'),
        dataIndex: 'title',
        ellipsis: true,
        sorter: dataGridTextSorter('title'),
        defaultSortOrder: 'ascend',
        ...titleTextFilterProps,
      },
      {
        title: t('URL'),
        dataIndex: 'url',
        ellipsis: true,
        sorter: dataGridTextSorter('url'),
        ...titleUrlFilterProps,
      },
    ],
    [t, titleTextFilterProps],
  );

  if (!links) {
    return <Spinner />;
  }

  return (
    <>
      <DataGrid
        rowKey={(link) => link.id}
        columns={columns}
        dataSource={links || []}
        permissionsBasic={'useful-links'}
        uniqueTableId={'useful-links-table'}
        onEditClick={onDetailClick}
        onRowClick={onDetailClick}
        onDelete={onDelete}
      />
    </>
  );
};

UsefulLinksTable.propTypes = {
  links: PropTypes.array,
  onDelete: PropTypes.func,
  onDetailClick: PropTypes.func,
  onCreateClick: PropTypes.func,
};

export default UsefulLinksTable;
